import {
  createConstituentComplaintTask,
  deleteConstituentComplaintTask,
  listConstituentComplaintTasks,
  updateConstituentComplaintTask,
} from "@/api/constituent_complaint_tasks";
import { WorkflowTaskChecklist } from "@/components/workflow_tracking/WorkflowTaskChecklist";
import { invalidateTrustSuitePipeline } from "@/lib/trustSuiteQueryKeys";

type ComplaintTasksProps = {
  municipalityId: number;
  complaintId: number;
};

export function ComplaintTasks({ municipalityId, complaintId }: ComplaintTasksProps) {
  const tasksQueryKey = ["constituent_complaint_tasks", municipalityId, complaintId] as const;
  const eventsQueryKey = ["constituent_complaint_events", municipalityId, complaintId] as const;

  return (
    <WorkflowTaskChecklist
      testId="trust-complaint-tasks"
      heading="Tasks"
      description="Track follow-up steps for this concern."
      tasksQueryKey={tasksQueryKey}
      eventsQueryKey={eventsQueryKey}
      listTasks={() => listConstituentComplaintTasks(municipalityId, complaintId)}
      createTask={(payload) => createConstituentComplaintTask(municipalityId, complaintId, payload)}
      updateTask={(taskId, patch) =>
        updateConstituentComplaintTask(municipalityId, complaintId, taskId, patch)
      }
      deleteTask={(taskId) => deleteConstituentComplaintTask(municipalityId, complaintId, taskId)}
      onInvalidatePipeline={(queryClient) => invalidateTrustSuitePipeline(queryClient, municipalityId)}
    />
  );
}
